<template>
  <new-modal-wrapper
    :widthModal="'80%'"
    :maxWidthModal="500"
    ref="NewPlacementWarningModal"
    modal-name="NewPlacementWarningModal"
    :show-close-icon="true"
    :click-to-close="true"
    :cta-secondary-button="isApparel ? null : 'placementWarningGoBack'"
    :cta-primary-button="isApparel ? 'apparelPlacementWarningGoBack' : 'placementWarningContinue'"
    :show-cta-secondary-button="!isApparel"
    @cta-action="onContinue"
    @cta-secondary-action="closeModal"
    :overrideFocusValue="true"
  >
    <div v-if="isApparel">
      <div class="new-modal-error-icon">!</div>
      <h2 class="new-modal-title">{{ translations.apparelPlacementWarningHeader }}</h2>
      <p class="new-modal-description">
        {{ translations.apparelPlacementWarningDesc }}
      </p>
    </div>
    <div v-else>
      <div class="new-modal-error-icon">!</div>
      <h2 class="new-modal-title">{{ translations.placementWarningHeader }}</h2>
      <p class="new-modal-description">
        {{ translations.placementWarningDesc }}
      </p>
    </div>
  </new-modal-wrapper>
</template>

<script>
import newModalWrapper from '@/components/Modals/NewModalWrapper/NewModalWrapper';

export default {
  name: "NewPlacementWarningModal",
  components: {
    newModalWrapper
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    isApparel() {
      return this.$store.getters['utils/isApparelEnabled'];
    }
  },
  methods: {
    /**
     * @function onContinue
     * Fires event to continue UGC flow
     */
    onContinue() {
      this.closeModal();
      this.$eventBus.$emit("placement-warning-continue");
    },
    /**
     * @function closeModal
     * Closes Placement Warning modal
     */
    closeModal() {
      this.$modal.hide("NewPlacementWarningModal");
      this.$nextTick(()=>{
        document.querySelector("#close-button-newUgcModal").focus();
      })
    }
  },
};
</script>
